module.exports = __webpack_public_path__ + "0a8e1b50672362bb6cc474cb7c864c26.svg";